<template>

  <div>
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
              md="12"
              class="mb-2 mb-md-0"
          >
            <b-tabs v-model="currentTab">
              <b-tab title="produto">
                <template #title>
                  <feather-icon icon="BoxIcon"/>
                  <span>Produto</span>
                </template>

                <b-row>
                  <b-col
                      md="12"
                      class="mx-auto mb-2 mb-md-0 row justify-content-between align-items-center"
                  >
                    <div class="mb-1">
                      <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          v-b-modal.modal-add-custom-field
                          @click="resetFormCustomField"
                      >
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-50"
                        />
                        <span class="align-middle">Campos personalizado</span>
                      </b-button>
                    </div>
                    <!--                    <feather-icon-->
                    <!--                        :icon="spanderAll ? 'ChevronsUpIcon' : 'ChevronsDownIcon'"-->
                    <!--                        class="mr-50 cursor-pointer"-->
                    <!--                        @click="toggleCollapseALl()"-->
                    <!--                    />-->
                  </b-col>
                  <b-col
                      md="12"
                      class="mb-2 mb-md-0"
                  >
                    <app-collapse type="margin">

                      <app-collapse-item
                          :is-visible="true"
                          ref="refCollapeseCamposPersonalizados"
                          id-collapse="collapese-campos-personalizados"
                          icon="SettingsIcon"
                          title="Campos personalizados"
                          class-header-collapse="bg-gradient-primary text-white"
                          :count-fields="customFields.length"
                      >
                        <b-table
                            striped
                            class="px-0 pb-1"
                            table-class="table table-sm"
                            responsive="sm"
                            :fields="headerCustomFields"
                            :items="customFields"
                            :busy="customFieldsLoading"
                        >
                        <template #table-busy>
                          <div class="text-center my-2">
                            <b-spinner small class="align-middle mr-1"></b-spinner>
                            <strong>Carregando...</strong>
                          </div>
                        </template>
                          <template #cell(id)="data">
                            <iconfy
                                :icon="resolveTypeFieldIcon(data.item.type)"
                                :style="{ fontSize: '36px' }"
                            />
                          </template>
                          <template #cell(label)="data">
                            <b-media vertical-align="center flex-column">
                              <div>{{ data.item.label }}</div>
                              <small class="text-muted">{{ resolveTypeFieldText(data.item.type) }}</small>
                            </b-media>
                          </template>

                          <template #cell(quality_rules)="data">
                            <b-badge
                                v-if="data.item.required === true"
                                variant="light-danger">
                              Obrigatório
                            </b-badge>

                          </template>

                          <template #head(actions)="data">
                            <div class="text-center">
                              <span>{{ data.label.toUpperCase() }}</span>
                            </div>

                          </template>
                          <template #cell(actions)="data">
                            <div
                                style="gap: 10px;"
                                class="row justify-content-center"
                            >
                              <b-button
                                  variant="gradient-primary"
                                  title="Editar"
                                  class="btn-icon"
                                  @click="openEditModal(data.item)"
                              >
                                <feather-icon icon="EditIcon"/>
                              </b-button>

                              <b-button
                                  variant="gradient-danger"
                                  title="Deletar"
                                  class="btn-icon"
                                  @click="openModalDeleteCustomField(data.item)"
                              >
                                <feather-icon icon="TrashIcon"/>
                              </b-button>
                              <b-button
                                  variant="gradient-success"
                                  title="Copiar UUID"
                                  class="btn-icon"
                                  @click="copyUUIDField(data.item.uuid)"
                              >
                                <iconfy icon="pixelarticons:copy"/>
                              </b-button>
                            </div>
                          </template>
                        </b-table>
                      </app-collapse-item>

                      <app-collapse-item
                          ref="refCollapeseCamposPadrao"
                          icon="SettingsIcon"
                          id-collapse="collapese-campos-padrao"
                          title="Campos padrão"
                          class-header-collapse="bg-gradient-primary text-white"
                          :count-fields="defaultFields.length"
                      >
                        <b-table
                            striped
                            class="px-0 pb-1"
                            table-class="table table-sm"
                            responsive="sm"
                            :fields="headerCustomFields"
                            :items="defaultFields"
                            :busy="defaultFieldsLoading"
                        >
                        <template #table-busy>
                          <div class="text-center my-2">
                            <b-spinner small class="align-middle mr-1"></b-spinner>
                            <strong>Carregando...</strong>
                          </div>
                        </template>
                          <template #cell(id)="data">
                            <iconfy
                                :icon="resolveTypeFieldIcon(data.item.type)"
                                :style="{ fontSize: '36px' }"
                            />
                          </template>
                          <template #cell(label)="data">
                            <b-media vertical-align="center flex-column">
                              <div>{{ data.item.label }}</div>
                              <small class="text-muted">{{ resolveTypeFieldText(data.item.type) }}</small>
                            </b-media>
                          </template>

                          <template #cell(quality_rules)="data">
                            <div
                                style="gap: 10px;"
                                class="row justify-content-start"
                            >
                              <b-badge
                                  v-if="data.item.primaryKey === true"
                                  variant="light-warning">
                                Chavé primária
                              </b-badge>
                              <b-badge
                                  v-if="data.item.required === true"
                                  variant="light-danger">
                                Obrigatório
                              </b-badge>
                              <b-badge
                                  v-if="data.item.defaultValue !== null"
                                  variant="light-info">
                                {{ resolverDefaultValues(data.item.defaultValue) }}
                              </b-badge>
                              <b-badge
                                  v-if="data.item.autoIncrement === true"
                                  variant="light-danger">
                                Auto incremento
                              </b-badge>
                            </div>
                          </template>

                          <template #head(actions)="data">
                            <div class="text-center">
                              <span>{{ data.label.toUpperCase() }}</span>
                            </div>
                          </template>

                          <template #cell(actions)="data">
                            <div
                                style="gap: 10px;"
                                class="row justify-content-center"
                            >
                              <b-button
                                  variant="gradient-primary"
                                  title="Editar"
                                  class="btn-icon"
                                  @click="openEditModal(data.item)"
                                  >
                                  <feather-icon icon="EditIcon"/>
                              </b-button>
                            </div>
                          </template>
                        </b-table>
                      </app-collapse-item>
                    </app-collapse>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <ModalAddCustomField
        idModal="modal-add-custom-field"
        titleModal="Adicionar campo personalizado"
        :labelBtnOk="dataCustomField.id !== null ? 'Atualizar' : 'Adicionar'"
        v-model="dataCustomField"
        :type-options="typeOptionsCustomFields"
        @ok="handleCreateCustomField($event)"
        @cancel="resetFormCustomField()"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-custom-field"
        title="Deletar Campo"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim"
        @ok="handleDeletedCustomField(deletedCustomField.id)"
        @cancel="isDeleteModal = false"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar o campo <b>{{ deletedCustomField.label }}</b>?</p>
          <p>Após a remoção, não será possível recuperar os dados.</p>
        </div>
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  BSpinner,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAddCustomField from '@/views/app/campos-personalizado/list/ModalAddCustomField.vue';
import SLSitemExService from '@/services/SistemaDKP/SLSitemEx.service';
import SLSitemService from '@/services/SistemaDKP/SLSItem.service';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useList from './useList';

export default {
  components: {
    BAvatar,
    BLink,
    BMedia,
    ModalAddCustomField,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
    BSpinner,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        label: '',
        id: null,
      },
    };
  },
  computed: {},
  methods: {
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    async handleDeletedCustomField(id) {
      const sLSitemExService = new SLSitemExService();
      this.isDeleteModal = false;
      await sLSitemExService.destroy(id);
      await this.resetFormCustomField();
    },
    openEditModal(data) {
      this.dataCustomField = data;
      this.$bvModal.show('modal-add-custom-field');
    },
    resetFormCustomField() {
      this.dataCustomField = {
        id: null,
        label: '',
        type: 'VARCHAR',
        required: false,
      };
      this.listarCustomFields();
      this.listarFieldsPadrao();
    },
    copyUUIDField(uuid) {
      try {
        const tempTextarea = document.createElement('textarea');
        tempTextarea.value = uuid;
        tempTextarea.style.position = 'fixed';
        tempTextarea.style.opacity = '0';
        document.body.appendChild(tempTextarea);
        tempTextarea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextarea);

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Copiado com sucesso',
            text: 'UUID copiado com sucesso',
            icon: 'CoffeeIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao copiar para a área de transferência:', error);
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Não foi possível copiar o UUID',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
  },
  setup() {
    const customFieldsLoading = ref(true);
    const defaultFieldsLoading = ref(true);
    const sLSitemExService = new SLSitemExService();
    const sLSitemService = new SLSitemService();
    const customFields = ref([]);
    const defaultFields = ref([]);
    const dataCustomField = ref({
      id: null,
      label: '',
      type: 'VARCHAR',
      required: false,
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const refCollapeseCamposPadrao = ref(null);
    const refCollapeseCamposPersonalizados = ref(null);

    const handleCreateCustomField = async (dataForm) => {
      if (dataForm.isDefault) {
        return;
      }
      if (dataForm.id !== null) {
        await sLSitemExService.update(dataForm.id, dataForm);
        return;
      }
      await sLSitemExService.store(dataForm);

      await listarCustomFields();
    };

    const listarCustomFields = async () => {
      customFieldsLoading.value = true;
      try {
        customFields.value = await sLSitemExService.index();
      } catch (error) {
        console.error('Error loading custom fields:', error);
      } finally {
        customFieldsLoading.value = false;
      }
    };

    const listarFieldsPadrao = async () => {
      defaultFieldsLoading.value = true;
      try {
        defaultFields.value = await sLSitemService.getItemDescribe();
      } catch (error) {
        console.error('Error loading default fields:', error);
      } finally {
        defaultFieldsLoading.value = false;
      }
    };

    const removerCustomField = async (id) => {

    };

    onMounted(async () => {
      await listarCustomFields();
      await listarFieldsPadrao();
    });
    const toggleCollapseALl = () => {
      spanderAll.value = !spanderAll.value;
    };
    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolverDefaultValues,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,

      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      refCollapeseCamposPadrao,
      refCollapeseCamposPersonalizados,
      toggleCollapseALl,
      currentTab,
      dataCustomField,
      typeOptionsCustomFields,
      handleCreateCustomField,
      listarCustomFields,
      customFields,
      removerCustomField,
      listarFieldsPadrao,
      defaultFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolverDefaultValues,
      customFieldsLoading,
      defaultFieldsLoading,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
